(function(module) {
        'use strict';

        function GroupsCtrl(utils, Group, App, Includes, Store, $state, $timeout, $scope, $mdDialog, Display, envService, Playlist, ListModifier, AppStylesInPlaylist, groupBulkAssign) {

            this.createAppStylesInPlaylist = (playlists, apps) => {
                playlists.forEach((playlist) => {
                    this.appsWithStylesInPlaylist = AppStylesInPlaylist.getAppStylesInPlaylist(playlist.apps, apps);
                    playlist.appsWithStyles = [];
                    playlist.appsWithStyles = this.appsWithStylesInPlaylist;

                });
            };

            this.addAppPlaylistStylesWhenFromGroup = (playlists, groups) => {
                groups.forEach((group) => {
                    if (group.playlistId && group.playlists && group.playlists.id) {
                        playlists.forEach((playlist) => {
                            if (group.playlistId === playlist.id) {
                                group.playlists.apps = playlist.appsWithStyles;
                            }
                        });
                    }
                });
            };

            this.setDefault = () => {
                this.groups = null;
                this.apps = null;
                this.playlists = null;

                this.loading = true;
                this.selectAllCheckbox = false;
                this.selectedCount = 0;
            };

            this.getData = () => {
                this.getGroups()
                    .then((response) => {
                        this.loading = false;
                        this.groups = Store.setMultiModelData('groups', response);
                        Promise.all([this.getApps(), this.getPlaylists()]).then(([apps, playlists]) => {
                            this.apps = Store.setMultiModelData('apps', apps);
                            this.playlists = Store.setMultiModelData('apps', playlists);
                            this.createAppStylesInPlaylist(playlists, apps);
                            this.addAppPlaylistStylesWhenFromGroup(this.playlists, this.groups);

                            if (!$scope.$$phase) {
                                $timeout(() => {
                                    $scope.$apply();
                                });
                            }
                        });
                    });
            };

            this.onSubAccountChange = () => {

                this.$onDestroy();
                this.setDefault();
                this.getData();
            };

            this.$onInit = () => {
                this.utils = utils;
                this.orderBy = 'name';
                this.cardModel = {
                    title: 'Create your first group',
                    subtitle: 'Groups allow you to manage multiple displays in one place',
                };
                this.featuresFlag = envService.read('features');
                this.setDefault();
                this.getData();
            };

            this.$onDestroy = () => {
            };

            this.getGroups = () => {
                return Group
                    .find({ filter: Includes.groups })
                    .$promise;
            };

            this.getApps = () => {
                return App
                    .find({ filter: Includes.apps })
                    .$promise;
            };

            this.getPlaylists = () => {
                return Playlist
                    .find()
                    .$promise;
            };

            this.getGroupsWithIds = (ids) => {
                return Group.find({
                    where: { id: { inq: ids } },
                    filter: Includes.groups,
                }).$promise;
            };

            this.openMenu = ($mdOpenMenu, event) => {
                if (this.selectedCount.length) {
                    return false;
                } else {
                    $mdOpenMenu(event);
                }
            };

            this.updateAllGroups = (data) => {
                const selectedGroupsIds = _.chain(this.groups)
                    .filter({ selected: true })
                    .map((item) => item.id)
                    .value();

                const query = groupBulkAssign.buildSelectedGroupsQuery(selectedGroupsIds);

                Group.updateAll(query, data)
                    .$promise

                    // include relationships are only available on find so we need to re-fetch the data
                    // https://docs.strongloop.com/display/public/LB/Include+filter
                    .then(() => {
                        return this.getGroupsWithIds(selectedGroupsIds);
                    })
                    .then((response) => {
                        // for each item in the response update the view
                        _.forEach(response, (item) => ListModifier.update(this.groups, item));
                        this.createAppStylesInPlaylist(this.playlists, this.apps);
                        this.addAppPlaylistStylesWhenFromGroup(this.playlists, this.groups);
                    })
                    .then(() => {
                        this.selectAllCheckbox = false;
                    })
                    .catch((error) => {
                        console.error('error', error);
                    });
            };

            this.beforeClearingModal = (type) => {

                $mdDialog.show({
                    locals: {
                        title: `Are you sure you want to clear ${type} assignment for all selected groups?`,
                        confirmText: 'Yes, clear',
                        confirmationText: 'Please note that any displays using the selected groups will be affected.',
                    },
                    controller: ($scope, $mdDialog) => {
                        $scope.cancel = () => {
                            $mdDialog.hide();
                        };
                        $scope.confirm = () => {
                            if (type === 'app') {
                                this.updateAllGroups({ appId: null });
                            }

                            if (type === 'playlist') {
                                this.updateAllGroups({ playlistId: null });
                            }
                            $scope.cancel();

                        };
                    },
                    controllerAs: '$ctrl',
                    bindToController: true,
                    templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                    parent: angular.element('body'),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                });

            };

            this.bulkAssignmentModal = (type, dataToUpdate) => {
                const modalTypeOverride = 'information';
                $mdDialog.show({
                    locals: {
                        title: `You are assigning a new ${type} to the selected groups. Would you like to continue?`,
                        confirmText: 'Yes',
                        modalTypeOverride: modalTypeOverride,
                    },
                    controller: ($scope, $mdDialog) => {
                        $scope.cancel = () => {
                            $mdDialog.hide();
                        };
                        $scope.confirm = () => {
                            this.updateAllGroups(dataToUpdate);

                            $scope.cancel();

                        };
                    },
                    controllerAs: '$ctrl',
                    bindToController: true,
                    templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                    parent: angular.element('body'),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                });
            };

            this.assignApp = (appId) => {
                if (!appId) {
                    this.beforeClearingModal('app');

                } else {
                    const dataToUpdate = groupBulkAssign.buildAssignAppPayload(appId);
                    this.bulkAssignmentModal('app', dataToUpdate);

                }

            };

            this.addToPlaylist = (playlistId) => {
                if (!playlistId) {
                    this.beforeClearingModal('playlist');
                } else {
                    const dataToUpdate = groupBulkAssign.buildAddToPlaylistPayload(playlistId);
                    this.updateAllGroups(dataToUpdate);
                }
            };

            this.selectAll = () => {
                this.filteredItems.forEach((group) => {
                    group.selected = this.selectAllCheckbox;
                });
                this.updateSelectedCount();
            };

            this.updateSelectedCount = () => {
                this.selectedCount = _.chain(this.groups).filter((group) => group.selected).size().value();
            };

            this.select = () => {
                this.updateSelectedCount();
            };

            this.findDisplaysUsingGroupId = (groupIds) => {
                return Display
                    .find({
                        filter: {
                            where: { groupId: { inq: groupIds } },
                            fields: ['id'],
                        },
                    })
                    .$promise;

            };

            this.delete = () => {
                const ids = _.chain(this.groups)
                    .filter({ selected: true })
                    .map((item) => item.id)
                    .value();

                this.findDisplaysUsingGroupId(ids).then((response) => {
                    const displaysUsingGroupCount = response && response.length;
                    let modalTitle;
                    let modalConfirmationText;
                    let modalCancelText;
                    let modalConfirmText;
                    let confirmActionFunc;
                    let itemCount1;

                    //if 1 selected group and used by displays
                    if (ids.length >= 1 && displaysUsingGroupCount > 0) {
                        modalTitle = 'You can\'t delete selected group/s as being used by :';

                        itemCount1 = displaysUsingGroupCount > 0 ? `${displaysUsingGroupCount + ' of your displays'}` : null;

                        modalConfirmationText = 'Please make sure the groups are not being used before deleting.';
                        modalCancelText = 'Ok, I understand';

                        //if more than 1 group selected and used by displays

                    } else {
                        modalTitle = 'Are you sure you want to permanently remove selected groups?';
                        modalConfirmText = 'Yes, remove';
                        modalCancelText = 'Cancel';
                        confirmActionFunc = (ids) => {
                            return Group.destroyAll({
                                where: { id: { inq: ids } },
                            })
                                .$promise
                                .then(() => {
                                    _.remove(this.groups, (group) => _.indexOf(ids, group.id) >= 0);
                                    this.selectAllCheckbox = false;
                                })
                                .catch((error) => {
                                    console.error('error', error);
                                });
                        };
                    }

                    $mdDialog.show({
                        locals: {
                            title: modalTitle,
                            confirmationText: modalConfirmationText,
                            cancelText: modalCancelText,
                            confirmText: modalConfirmText,
                            itemCount1: itemCount1,
                        },
                        controller: ($scope, $mdDialog) => {
                            $scope.cancel = () => {
                                $mdDialog.hide();
                            };
                            $scope.confirm = () => {
                                $scope.cancel();

                                confirmActionFunc(ids);
                            };
                        },
                        controllerAs: '$ctrl',
                        bindToController: true,
                        templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                        parent: angular.element('body'),
                        clickOutsideToClose: true,
                        escapeToClose: true,
                    });

                });

            };

            this.getGroupById = (updatedGroupId) => {
                return Group.findById({
                    id: updatedGroupId,
                    filter: Includes.groups,
                }).$promise;
            };

        }

        module
            .config(($stateProvider, $translatePartialLoaderProvider) => {
                $stateProvider.state('root.groups', {
                    url: '/groups',
                    data: {
                        pageTitle: 'GROUPS.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<groups-component />',
                        },
                    },
                    bodyClass: 'page--groups',
                });

                // Translations
                $translatePartialLoaderProvider.addPart('/js/groups');

            })
            .component('groupsComponent', {
                templateUrl: '/js/groups/groups.html',
                controller: GroupsCtrl,
            });

    }

)(angular.module('rocket.components'));
